import type { RootState } from "types/redux";

export const getSelectedTheme = (state: RootState) => state.domains.theme.selected;
